export default __webpack_public_path__ + "static/media/Group1295@2x.eff39101.png";